import styled from "styled-components";
import {Col, Row, Select} from "antd";

export const OptionsRow = styled(Row)`
    @media (max-width: 768px) {
        width: 100%;
        heigh: 100%;
    }
`;

export const ButtonContainer = styled.div`
    margin-bottom: 20px;
`;

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            min-width: 197px;
            font-size: 12px;
        }
    }
`;

export const ExcelButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
`;
export const ListItemContainer = styled(Col)`
    margin-top: 10px;
`;

export const ListItem = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 5px;
    padding-right: 5px;
    border: 1px solid #e8e8e8;
`;
